module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "mod-index"
  }, [_c('hd', {
    attrs: {
      "bus": _vm.bus
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "index-bd",
    attrs: {
      "span": 24
    }
  }, [_c('left', {
    attrs: {
      "bus": _vm.bus
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "mod-section",
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    staticClass: "mod-breadcrumb"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 您的位置 : ")]), _vm._v(" "), _c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path,
      attrs: {
        "to": item.path
      }
    }, [(!item.meta.needHide) ? _c('span', {
      staticClass: "jLastNavName"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()])
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('ft')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6891ebe","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/conf/index/index.vue
// module id = 278
// module chunks = 123